import { useQuery } from '@tanstack/react-query'
import { v1OrganizationsApi } from '../api'

export function useOrganizationDetail(id: string) {
  return useQuery({
    queryKey: ['v1', 'organizations', id],
    queryFn: () => v1OrganizationsApi.getOrganizationById(id),
    enabled: !!id
  })
}
